import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=3840e494&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"
import style0 from "./exchange.vue?vue&type=style&index=0&id=3840e494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3840e494",
  null
  
)

export default component.exports